if (!customElements.get("m-icon-box")) {
  class MIconbox extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".swiper-container");
      this.scrollContainer = this.querySelector("[data-scroll-container]");
      this.progressBar = this.querySelector("[data-scroll-progress]");
      this.progressFill = this.querySelector("[data-scroll-progress-fill]");
      this.totalItemsAttr = parseInt(this.dataset.totalItems || '0', 10);
      this.visibleItemsAttr = parseInt(this.dataset.visibleItems || '3', 10);
      
      // Fallback: find the mobile scroll container
      if (!this.scrollContainer) {
        this.scrollContainer = this.querySelector(".m-mixed-layout--mobile-scroll");
      }
    }

    connectedCallback() {
      this.lastActive = null;
      if (this.enableSlider) {
        this.initSlider();
      } else {
        this.initScrollProgress();
      }
    }

    initSlider() {
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = this.querySelector(".swiper-wrapper").childElementCount;
      let __this = this;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1,
        navigation: this.showNavigation,
        loop: true,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          480: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: parseInt(this.items) - 1,
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        on: {
          init: function () {
            this.slideToLoop(this.lastActive);
            setTimeout(() => {
              // Calculate controls position
              const firstItem = __this.querySelector(".m-image") || __this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton.classList.remove("m:hidden");
                nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }
      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    initScrollProgress() {
      if (!this.scrollContainer || !this.progressBar || !this.progressFill) {
        console.log('Progress bar elements not found:', {
          scrollContainer: !!this.scrollContainer,
          progressBar: !!this.progressBar,
          progressFill: !!this.progressFill
        });
        return;
      }
      
      const updateProgress = () => {
        // Check if we're on mobile and have horizontal scroll enabled
        const isMobile = window.innerWidth <= 767;
        const mobileScrollContainer = this.querySelector('.m-mixed-layout--mobile-scroll');
        
        if (!isMobile || !mobileScrollContainer) {
          this.progressBar.style.display = 'none';
          return;
        }
        
        this.progressBar.style.display = 'block';
        
        // Use the mobile scroll container for scroll measurements
        const actualScrollContainer = mobileScrollContainer;
        const scrollLeft = actualScrollContainer.scrollLeft;
        const scrollWidth = actualScrollContainer.scrollWidth;
        const clientWidth = actualScrollContainer.clientWidth;
        const maxScroll = Math.max(0, scrollWidth - clientWidth);

        if (scrollWidth <= 0 || clientWidth <= 0) {
          this.progressFill.style.width = '0%';
          return;
        }

        if (maxScroll <= 0) {
          this.progressFill.style.width = '100%';
          return;
        }

        // Progress based on visible items ratio at start, then scale with scroll
        // Derive total items from DOM after layout to avoid backend mismatch
        let totalItems = this.querySelectorAll('.m-mixed-layout__inner > .m\\:column').length;
        if (!totalItems) totalItems = this.querySelectorAll('.m-mixed-layout__inner > *').length;

        const visibleItems = 3;
        const visibleRatio = totalItems > 0 ? Math.min(1, visibleItems / totalItems) : Math.min(1, clientWidth / Math.max(1, scrollWidth));
        const scrollProgress = maxScroll > 0 ? scrollLeft / maxScroll : 0; // 0..1
        const progress = (visibleRatio + scrollProgress * (1 - visibleRatio)) * 100;
        let finalProgress = Math.min(100, Math.max(0, progress));
        // Default display at 50% when at initial position
        if (scrollLeft === 0) finalProgress = 50;
        this.progressFill.style.width = finalProgress + '%';
        
        // Also set background color directly to ensure visibility
        this.progressFill.style.backgroundColor = '#007bff';
        
        // Force style update and add debugging
        console.log('Setting progress fill width to:', finalProgress + '%');
        console.log('Progress fill element:', this.progressFill);
        console.log('Progress fill computed style:', window.getComputedStyle(this.progressFill).width);
      };
      
      // Handle progress bar click
      const handleProgressClick = (e) => {
        const isMobile = window.innerWidth <= 767;
        const mobileScrollContainer = this.querySelector('.m-mixed-layout--mobile-scroll');
        
        if (!isMobile || !mobileScrollContainer) return;
        
        const rect = this.progressBar.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const progressBarWidth = rect.width;
        const clickProgress = clickX / progressBarWidth;
        
        const scrollWidth = mobileScrollContainer.scrollWidth;
        const clientWidth = mobileScrollContainer.clientWidth;
        const maxScroll = scrollWidth - clientWidth;
        
        const targetScrollLeft = clickProgress * maxScroll;
        
        console.log('Click progress:', clickProgress, 'Target scroll:', targetScrollLeft);
        
        // Smooth scroll to target position
        mobileScrollContainer.scrollTo({
          left: targetScrollLeft,
          behavior: 'smooth'
        });
      };
      
      // Add event listeners
      const addScrollListener = () => {
        const mobileScrollContainer = this.querySelector('.m-mixed-layout--mobile-scroll');
        if (mobileScrollContainer) {
          mobileScrollContainer.addEventListener('scroll', updateProgress, { passive: true });
        }
      };
      
      addScrollListener();
      this.progressBar.addEventListener('click', handleProgressClick);
      
      // Initial update after layout
      requestAnimationFrame(() => setTimeout(updateProgress, 150));
      
      // Update on resize and re-add listeners
      window.addEventListener('resize', () => {
        setTimeout(() => {
          updateProgress();
          addScrollListener();
        }, 100);
      });
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-icon-box", MIconbox);
}
